// Bilingual dictionary for Dhon Studio
export const translations = {
  id: {
    nav: {
      services: "Jasa",
      pricing: "Harga",
      work: "Klien",
      why: "Keunggulan",
      tech: "Teknologi",
      owner: "Pemilik",
      contact: "Kontak",
    },
    hero: {
      tagWeBuild: "Kami Bangun.",
      tagWeFix: "Kami Perbaiki.",
      tagWeDeploy: "Kami Tayangkan.",
      sub: "Kami mengubah ide menjadi produk web yang mulus — dari pengkodean baris pertama hingga server menyala. Lokal Indonesia, jangkauan global.",
      ctaPrimary: "Lihat Jasa Kami",
      ctaSecondary: "Join Komunitas",
      pillBadge: "Dhon Studio — Sejak hari pertama",
    },
    sectionLabels: {
      services: "01 — Yang Kami Tawarkan",
      pricing: "02 — Paket Harga",
      clients: "03 — Klien Kami",
      why: "04 — Mengapa Memilih Kami",
      details: "05 — Detail Pekerjaan",
      tech: "06 — Teknologi",
      owner: "07 — Pemilik & Penanggung Jawab",
      contact: "08 — Sapa Kami",
    },
    pricing: {
      title: "Paket harga yang\ntransparan & fleksibel.",
      sub: "Pilih paket yang sesuai dengan kebutuhan Anda — tanpa biaya tersembunyi.",
      items: [
        {
          n: "01",
          title: "Starter",
          price: "Rp 500.000",
          period: "/proyek",
          highlight: "Cocok untuk UMKM atau proyek kecil, mulai dari:",
          features: [
            "Website company profile / landing page",
            "Desain responsif mobile-first",
            "SEO dasar & optimasi performa",
            "1x revisi desain",
            "Dukungan 7 hari setelah launch"
          ],
          cta: "Pilih Starter",
          accent: "#ccff00"
        },
        {
          n: "02",
          title: "Pro",
          price: "Rp 2.500.000",
          period: "/proyek",
          highlight: "Untuk bisnis yang siap berkembang, mulai dari:",
          features: [
            "Website dengan CMS atau WebApp sederhana",
            "Autentikasi pengguna & dashboard dasar",
            "Desain custom",
            "3x revisi",
            "Integrasi API (max 2)",
            "Dukungan 30 hari setelah launch"
          ],
          cta: "Pilih Pro",
          accent: "#ff4500",
          popular: true
        },
        {
          n: "03",
          title: "Enterprise",
          price: "Hubungi Kami",
          period: "",
          highlight: "Untuk proyek skala besar & kustom",
          features: [
            "WebApp full-stack kustom",
            "Multi-role autentikasi",
            "Integrasi tanpa batas",
            "CI/CD & deployment otomatis",
            "Refactoring & audit kode",
            "Dukungan prioritas 24/7"
          ],
          cta: "Diskusikan Kebutuhan",
          accent: "#ff00cc"
        }
      ]
    },
    services: {
      title: "Jasa yang kami\nkerjakan dengan presisi.",
      sub: "Enam layanan inti yang dirancang untuk memuluskan perjalanan digital bisnis Anda — dari ide, sketsa, hingga domain yang siap tayang.",
      items: [
        {
          n: "01",
          title: "Pengembangan Website",
          short: "Website company profile, landing page, dan situs berbasis konten yang cepat, responsif, dan SEO friendly.",
        },
        {
          n: "02",
          title: "Pengembangan WebApps",
          short: "Aplikasi web full-stack dengan autentikasi, dashboard, dan integrasi pihak ketiga sesuai kebutuhan operasional.",
        },
        {
          n: "03",
          title: "Desain UI",
          short: "Antarmuka yang manusiawi, terdokumentasi, dan siap diperbaharui.",
        },
        {
          n: "04",
          title: "Error & Bug Fixing",
          short: "Investigasi mendalam atas bug yang membandel, hotfix produksi, hingga audit kualitas kode legacy.",
        },
        {
          n: "05",
          title: "Deployment",
          short: "Publikasi aplikasi ke server, konfigurasi DNS, sertifikat SSL, dan pengaturan CI/CD yang rapi.",
        },
        {
          n: "06",
          title: "Migrasi Hosting / Domain",
          short: "Pemindahan situs antar penyedia hosting maupun registrar domain tanpa downtime dan tanpa drama.",
        },
      ],
    },
    why: {
      title: "Mengapa banyak klien\nbertahan dengan kami.",
      items: [
        {
          n: "01",
          title: "Tim IT Berpengalaman",
          desc: "Engineer kami sudah menempuh ribuan jam coding lintas proyek — dari kebutuhan UMKM hingga sistem berskala komunitas.",
        },
        {
          n: "02",
          title: "Portofolio Terbukti",
          desc: "Sederet klien aktif yang masih mempercayakan pemeliharaan dan pengembangan lanjutan kepada kami sebagai bukti komitmen.",
        },
        {
          n: "03",
          title: "Pendampingan End-to-End",
          desc: "Dari diskusi anggaran, perancangan, hingga setelah deployment — kami menemani setiap fase agar Anda tidak berjalan sendirian.",
        },
        {
          n: "04",
          title: "Harga Kompetitif",
          desc: "Penawaran transparan, fleksibel, dan disesuaikan dengan skala bisnis Anda — tanpa biaya tersembunyi.",
        },
        {
          n: "05",
          title: "Bukan Vibe Coder",
          desc: "Meskipun kami menggunakan AI untuk mempercepat proses, setiap baris kode tetap di-review dan dipelihara dengan standar engineering yang ketat — jaminan maintenance dan update selalu tersedia.",
        },
      ],
    },
    clients: {
      title: "Klien yang telah\nmempercayakan kami.",
      sub: "Mereka yang masih aktif kami bantu — mulai dari pembuatan hingga pemeliharaan berkelanjutan.",
      visit: "Kunjungi situs",
    },
    details: {
      title: "Detail pekerjaan\ndari setiap jasa.",
      sub: "Tidak ada pekerjaan yang dilakukan setengah hati. Begini cara kami menyelesaikannya:",
      items: [
        {
          n: "01",
          title: "Pengembangan Website",
          desc: "Mencakup analisis kebutuhan, perancangan struktur informasi, pemrograman front-end & back-end menggunakan HTML/CSS/JS/PHP/CodeIgniter, optimasi performa & SEO dasar, hingga peluncuran ke domain Anda.",
        },
        {
          n: "02",
          title: "Pengembangan WebApps",
          desc: "Membangun aplikasi web fungsional: sistem autentikasi & peran pengguna, modul CRUD, dashboard admin, REST API, integrasi pembayaran/pihak ketiga, hingga pengujian end-to-end.",
        },
        {
          n: "03",
          title: "Desain UI",
          desc: "Mulai dari riset hingga high-fidelity mockup. Dilengkapi komponen reusable dan mudah diperbaharui yang siap diuji ke pengguna.",
        },
        {
          n: "04",
          title: "Error & Bug Fixing",
          desc: "Reproduksi bug, root cause analysis, perbaikan kode, refactor minor jika diperlukan, dan dokumentasi solusi agar tim Anda dapat belajar serta mencegahnya di kemudian hari.",
        },
        {
          n: "05",
          title: "Deployment",
          desc: "Setup server (cPanel/VPS), konfigurasi domain & subdomain, penerbitan SSL, deployment via Git, pengaturan environment variable, dan validasi pasca-tayang.",
        },
        {
          n: "06",
          title: "Migrasi Hosting & Domain",
          desc: "Backup penuh data & basis data, transfer file, pengaturan ulang DNS, pengujian setelah migrasi, hingga rollback plan untuk meminimalkan risiko downtime.",
        },
      ],
      scope: {
        title: "Cakupan Wilayah",
        local: "Lokal Indonesia",
        global: "Global",
        desc: "Kami melayani klien di seluruh Indonesia maupun internasional — komunikasi dalam Bahasa Indonesia atau English, sesuai preferensi Anda.",
      },
    },
    tech: {
      title: "Teknologi\nyang kami gunakan.",
      sub: "Stabil, matang, dan tetap relevan untuk berbagai skala proyek.",
    },
    owner: {
      label: "Sosok owner",
      name: "Muhammad R., M.Kom.",
      bio: "Pemilik sekaligus pengembang utama Dhon Studio. Berlatar belakang Magister Komputer, ia telah mengantarkan berbagai proyek web ke tayang publik. Setiap baris kode dijaga kualitasnya secara langsung olehnya.",
      cta: "Lihat portofolio lengkap",
      link: "muhammadr.com",
    },
    footer: {
      bigText: "Mari\nNgobrol.",
      sub: "Punya ide, masalah teknis, atau ingin pindah hosting? Sapa kami kapan saja melalui sosial media.",
      threads: "Threads",
      instagram: "Instagram",
      copyright: "© {year} Dhon Studio. Semua hak dilindungi.",
      crafted: "Dirancang & dikembangkan dengan ketelitian di Indonesia.",
    },
  },
  en: {
    nav: {
      services: "Services",
      pricing: "Pricing",
      work: "Clients",
      why: "Why Us",
      tech: "Tech",
      owner: "Owner",
      contact: "Contact",
    },
    hero: {
      tagWeBuild: "We Build.",
      tagWeFix: "We Fix.",
      tagWeDeploy: "We Ship.",
      sub: "We turning ideas into seamless web products — from the first line of code to the moment your server lights up. Local in Indonesia, available worldwide.",
      ctaPrimary: "Explore Services",
      ctaSecondary: "Join Community",
      pillBadge: "Dhon Studio — Since day one",
    },
    sectionLabels: {
      services: "01 — What We Do",
      pricing: "02 — Pricing Plans",
      clients: "03 — Our Clients",
      why: "04 — Why Choose Us",
      details: "05 — How We Work",
      tech: "06 — Tech Stack",
      owner: "07 — Behind the Studio",
      contact: "08 — Say Hello",
    },
    pricing: {
      title: "Transparent & flexible\npricing plans.",
      sub: "Pick the plan that fits your needs — no hidden fees, no surprises.",
      items: [
        {
          n: "01",
          title: "Starter",
          price: "Rp 500,000",
          period: "/project",
          highlight: "Perfect for SMEs or small projects, start from:",
          features: [
            "Company profile / landing page",
            "Mobile-first responsive design",
            "Basic SEO & performance optimization",
            "1 design revision",
            "7 days post-launch support"
          ],
          cta: "Choose Starter",
          accent: "#ccff00"
        },
        {
          n: "02",
          title: "Pro",
          price: "Rp 2,500,000",
          period: "/project",
          highlight: "For growing businesses, start from:",
          features: [
            "Website with CMS or simple WebApp",
            "User authentication & basic dashboard",
            "Custom design",
            "3 revisions",
            "API integrations (max 2)",
            "30 days post-launch support"
          ],
          cta: "Choose Pro",
          accent: "#ff4500",
          popular: true
        },
        {
          n: "03",
          title: "Enterprise",
          price: "Contact Us",
          period: "",
          highlight: "For large-scale & custom projects",
          features: [
            "Full-stack custom WebApp",
            "Multi-role authentication",
            "Unlimited integrations",
            "CI/CD & automated deployment",
            "Refactoring & code audit",
            "Priority 24/7 support"
          ],
          cta: "Discuss Your Needs",
          accent: "#ff00cc"
        }
      ]
    },
    services: {
      title: "Services we\ncraft with precision.",
      sub: "Six core offerings designed to smooth your digital journey — from ide, sketches, to a live domain.",
      items: [
        {
          n: "01",
          title: "Website Development",
          short: "Fast, responsive, SEO-friendly websites: company profiles, landing pages, and content-driven sites.",
        },
        {
          n: "02",
          title: "WebApp Development",
          short: "Full-stack web applications with auth, dashboards, and the third-party integrations your team actually needs.",
        },
        {
          n: "03",
          title: "UI Design",
          short: "Human-centred interfaces, documented and ready to update.",
        },
        {
          n: "04",
          title: "Error & Bug Fixing",
          short: "Deep dives on stubborn bugs, production hotfixes, and quality audits for your legacy codebase.",
        },
        {
          n: "05",
          title: "Deployment",
          short: "Shipping your app to a server, configuring DNS, SSL certificates, and tidy CI/CD pipelines.",
        },
        {
          n: "06",
          title: "Hosting / Domain Migration",
          short: "Move your site between hosting providers or registrars — zero downtime, zero drama.",
        },
      ],
    },
    why: {
      title: "Why our clients\nkeep coming back.",
      items: [
        {
          n: "01",
          title: "Experienced IT Team",
          desc: "Our engineers have logged thousands of hours across projects — from small businesses to community-scale platforms.",
        },
        {
          n: "02",
          title: "Proven Portfolio",
          desc: "A line-up of active clients who keep trusting us with ongoing maintenance and new development — proof of real commitment.",
        },
        {
          n: "03",
          title: "End-to-end Guidance",
          desc: "From budget conversations to design, build, and after-deployment care — we walk every phase with you.",
        },
        {
          n: "04",
          title: "Competitive Pricing",
          desc: "Transparent, flexible offers tailored to your business size. No hidden costs, no surprises.",
        },
        {
          n: "05",
          title: "Not Vibe Coders",
          desc: "While we use AI to speed up our process, every line of code is still reviewed and maintained with strict engineering standards — maintenance and update guarantees always available.",
        },
      ],
    },
    clients: {
      title: "Trusted by builders\nwho keep building.",
      sub: "A handful of them we still actively support — from initial launch to long-term maintenance.",
      visit: "Visit site",
    },
    details: {
      title: "Inside the work\nbehind each service.",
      sub: "Nothing here is done half-heartedly. This is how we actually do it:",
      items: [
        {
          n: "01",
          title: "Website Development",
          desc: "Needs analysis, information architecture, front-end & back-end coding with HTML/CSS/JS/PHP/CodeIgniter, performance and basic SEO optimisation — all the way to launch on your domain.",
        },
        {
          n: "02",
          title: "WebApp Development",
          desc: "Functional web apps: authentication & role management, CRUD modules, admin dashboards, REST APIs, payment & third-party integrations, plus end-to-end testing.",
        },
        {
          n: "03",
          title: "UI Design",
          desc: "Research and high-fidelity mockups. Delivered with a reusable components and easily updatable ready for user testing.",
        },
        {
          n: "04",
          title: "Error & Bug Fixing",
          desc: "Bug reproduction, root cause analysis, fixes, light refactors where needed, and clear write-ups so your team can learn and prevent recurrence.",
        },
        {
          n: "05",
          title: "Deployment",
          desc: "Server setup (cPanel/VPS), domain & subdomain config, SSL issuance, Git-based deploys, environment variable management, and post-launch validation.",
        },
        {
          n: "06",
          title: "Hosting & Domain Migration",
          desc: "Full data & database backups, file transfers, DNS reconfiguration, post-migration testing, and a rollback plan to minimise downtime risk.",
        },
      ],
      scope: {
        title: "Where We Work",
        local: "Local — Indonesia",
        global: "Global",
        desc: "We serve clients across Indonesia and internationally — communicating in Bahasa Indonesia or English, whichever you prefer.",
      },
    },
    tech: {
      title: "The stack we\nactually ship with.",
      sub: "Stable, mature, and still relevant across project sizes.",
    },
    owner: {
      label: "The owner face",
      name: "Muhammad R., M.S.C.",
      bio: "Owner and lead developer of Dhon Studio. With a Master of Science in Computing background, he has shipped various of web projects into production. Every line of code is personally watched over by him.",
      cta: "View full portfolio",
      link: "muhammadr.com",
    },
    footer: {
      bigText: "Let's\nTalk.",
      sub: "Got an idea, a tricky bug, or a hosting move on your mind? Slide into our socials — we read everything.",
      threads: "Threads",
      instagram: "Instagram",
      copyright: "© {year} Dhon Studio. All rights reserved.",
      crafted: "Designed & engineered with care in Indonesia.",
    },
  },
};

export const CLIENTS = [
  { name: "befin.id", url: "https://befin.id", desc: { id: "Platform komunitas digital", en: "Digital community platform" } },
  { name: "sobatemas.com", url: "https://sobatemas.com", desc: { id: "Komunitas investasi emas", en: "Gold investing community" } },
  { name: "mamashii.id", url: "https://mamashii.id", desc: { id: "Brand & commerce", en: "Brand & commerce" } },
  { name: "gaic.life", url: "https://gaic.life", desc: { id: "Platform lingkungan perumahan", en: "Residential management platform" } },
  // { name: "masukkelas.id", url: "https://masukkelas.id", desc: { id: "Edukasi & kelas", en: "Education & classes" } },
  { name: "gmsuksesindo.com", url: "https://gmsuksesindo.com", desc: { id: "Profil perusahaan", en: "Company profile" } },
];

export const SOCIALS = {
  threads: "https://www.threads.com/@dhonstudio",
  instagram: "https://www.instagram.com/dhonstudio/",
};

export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_dhon-studio/artifacts/hc7w3xmh_logo_white.png";
